import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import moment from 'moment-timezone'
import Divider from 'material-ui/Divider'
import styles from './styles/calendar.css'
import constants from './constants'

const DayColumn = ({ date, handleBookingClick, numHours }) => {
  const dividerCountArr = Array.from({ length: numHours }, (_, i) => i)
  const classes = cx(styles.dayColumn, {
    [styles.today]: date.isSame(moment(), 'day'),
    [styles.past]: date.isBefore(moment(), 'day'),
  })
  return (
    <div className={classes}>
      <div className={styles.dayColumnHeader}>
        <span className={styles.dayOfWeek}>{date.format('ddd')}</span>
        <span className={styles.dayOfMonth}>{date.format('D')}</span>
      </div>
      {dividerCountArr.map((placeHolder, i) => (
        <div key={`${placeHolder}divider`}>
          <Divider />
          <div
            tabIndex={-1}
            className={styles.hourRow}
            role="button"
            onClick={(e) => {
              handleBookingClick(
                e,
                { start: date.hours(i + (constants.startOfDay - 1)) },
                true,
              )
            }}
          />
        </div>
      ))}
    </div>
  )
}

DayColumn.propTypes = {
  date: PropTypes.shape({
    clone: PropTypes.func.isRequired,
  }).isRequired,
  handleBookingClick: PropTypes.func.isRequired,
  numHours: PropTypes.number.isRequired,
}

export default DayColumn



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/DayColumn.js